// extracted by mini-css-extract-plugin
export default {"image":"background__image__EN8vH","color":"background__color__Y1Hjo","video":"background__video__C7DEx","videoEnabled":"background__videoEnabled__riZjS"};